export default __webpack_public_path__ + "static/media/qrCodeIos.65cc72d9.png";